module.exports = __webpack_public_path__ + "kudos_12.svg?83c923f834235d876e74a3df62131290";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_12.svg
// module id = 109
// module chunks = 0